import Service from "../../../service/api.js"

const SignupModule = {
    // namespaced: true,
    state: {
        dialogOTPHolder: false,
        secret: "",
        loadingSignup: false,
        showRegisterSuccessModal: false
    },
    mutations: {
        setLoadingSignup(state, val){
            state.loadingSignup = val
        },
        dialogOTPHolderMutation(state, res) {
            state.secret = res.data.secret
            state.dialogOTPHolder = true
        },
        closeDialog(state) {
            state.dialogOTPHolder = false
        },
        closeRegisterSuccessModal(state) {
            state.showRegisterSuccessModal = false
        },
        setShowingRegisterSuccessModal(state) {
            state.showRegisterSuccessModal = true
        },
    },
    actions: {
        confirmOTPaction({ commit }, payload) {
            Service.onVerifySignup(payload).then((res) => {
                commit('closeDialog')
                commit('setShowingRegisterSuccessModal')
            }).catch((err) => {
                alert("Error : Your OTP doesn't match, please re-enter your OTP by sign-in with your register email")
            })
        },
        onSignUp({ commit }, signupData) {
            commit('setLoadingSignup', true)
            Service.onSignup(signupData).then((res) => {
                commit('dialogOTPHolderMutation', res)
            }).catch((err) => {
                alert("Error : Username or Email has been used")
            }).finally(()=>{
                commit('setLoadingSignup', false)
            })
        },
    },

    getters: {
        dialogOTPHolderGetter(state) {
            return state.dialogOTPHolder;
        },
        OTPSecretGetter(state) {
            return state.secret;
        },
        registerSuccessStatus(state) {
            return state.showRegisterSuccessModal
        },
        getLoadingSignup(state){
            return state.loadingSignup
        }
    },
}
export default SignupModule